import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { radius, palette, themeMode, variant, color } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var sizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      fontSize: "sm",
      py: "lg",
      px: "lg"
    },
    md: {
      fontSize: "md",
      py: "md",
      px: "md"
    },
    lg: {
      fontSize: "lg",
      py: "lg",
      px: "lg"
    }
  }
});
var variantStyles = variant({
  prop: "variant",
  variants: {
    default: {
      background: themeMode({
        dark: "transparent",
        light: "neutral.0"
      }),
      color: themeMode({
        dark: "neutral.50",
        light: "neutral.900"
      }),
      border: "1px solid",
      borderColor: themeMode({
        dark: "neutral.600",
        light: "neutral.300"
      }),
      "&::placeholder": {
        color: themeMode({
          dark: "neutral.500",
          light: "neutral.400"
        })
      },
      "&:hover": {
        borderColor: themeMode({
          dark: "neutral.400",
          light: "neutral.500"
        })
      },
      "&:focus": {
        borderColor: themeMode({
          dark: "neutral.400",
          light: "neutral.500"
        })
      },
      "&:disabled": {
        cursor: "not-allowed",
        backgroundColor: themeMode({
          dark: "neutral.800",
          light: "neutral.100"
        }),
        color: themeMode({
          dark: "neutral.500",
          light: "neutral.400"
        }),
        borderColor: themeMode({
          dark: "neutral.800",
          light: "neutral.100"
        })
      }
    },
    ghost: {
      background: "transparent",
      color: themeMode({
        dark: "neutral.50",
        light: "neutral.900"
      }),
      border: "1px solid",
      borderColor: "transparent",
      "&::placeholder": {
        color: themeMode({
          dark: "neutral.400",
          light: "neutral.500"
        })
      },
      "&:hover": {
        "&::placeholder": {
          color: themeMode({
            dark: "neutral.50",
            light: "neutral.900"
          })
        }
      },
      "&:disabled": {
        cursor: "not-allowed",
        color: themeMode({
          dark: "neutral.500",
          light: "neutral.400"
        })
      }
    }
  }
});
var Textarea = styled(Box).attrs(function () {
  return {
    as: "textarea"
  };
}).withConfig({
  componentId: "dsnyvf-0"
})(["z-index:1;position:relative;line-height:normal;width:100%;color:inherit;background-color:transparent;border:none;appearance:none;transition:border-color 200ms ease-in,box-shadow 200ms ease-in;border-radius:", ";&::placeholder{transition:color 200ms ease-in;}&:focus{outline:none;}", ";border-color:", ";", ";", ";&:focus{box-shadow:", " 0px 0px 0px 1px;}"], radius("sm"), variantStyles, function (_ref) {
  var isInvalid = _ref.isInvalid;
  return isInvalid && palette("danger.500");
}, sizeStyles, function (_ref2) {
  var resize = _ref2.resize;
  return resize && "resize: " + resize;
}, themeMode({
  dark: color("neutral.50"),
  light: color("neutral.900")
}));
export { Textarea };